const searchParticipantsInGroups = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        isSearchingForParticipantsInGroups: true,
        searchingForParticipantsInGroupsQuery: action.query,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        isSearchingForParticipantsInGroups: false,
      };
    default:
      return state;
  }
};

export default searchParticipantsInGroups;
